import { render, staticRenderFns } from "./register.vue?vue&type=template&id=74f9e774&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=74f9e774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9e774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f9e774')) {
      api.createRecord('74f9e774', component.options)
    } else {
      api.reload('74f9e774', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=74f9e774&scoped=true&", function () {
      api.rerender('74f9e774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/SBP/register.vue"
export default component.exports